import {
  LOAD_DAY_MENU,
  LOAD_DAY_MENU_COMPLETE,
  LOAD_WEEKLY_MENU,
  LOAD_WEEKLY_MENU_COMPLETE
} from '../constants/actionTypes';

export const initialState = {
  menus: [],
  selectedMenu: null,
  loaded: false,
  allergensUrl: null
};

export default (state = initialState, action) => {
  const { type, menu, id, menus, allergensUrl, wellnessMenuUrl } = action;

  switch (type) {
    case LOAD_DAY_MENU:
      return { ...state, loaded: true };

    case LOAD_DAY_MENU_COMPLETE:
      return { ...state, menus: { ...state.menus, [id]: menu }, loaded: false };

    case LOAD_WEEKLY_MENU:
      return { ...state, menus: [], loaded: true };

    case LOAD_WEEKLY_MENU_COMPLETE:
      return {
        ...state,
        menus: { ...state.menus, ...menus },
        allergensUrl,
        wellnessMenuUrl,
        loaded: false
      };

    default:
      return state;
  }
};
